// extracted by mini-css-extract-plugin
module.exports = {"container":"PlainButton_container__3Lybw","label":"PlainButton_label__33Q4j"};